import type {LabelPickerLabel} from '@github-ui/item-picker-label-tsq'
import {ConnectionHandler, type RecordSourceProxy} from 'relay-runtime'

export type issueUpdateArgs = {
  applyLabelIds: string[]
  removeLabelIds: string[]
}

export function addLabelsToStore(store: RecordSourceProxy, labels: LabelPickerLabel[]) {
  // Create optimistic Label records with the provided fields so
  // issues can link to them immediately, as long as they do not yet exist.
  // If they do exist, still copy the values over, as they could be stale.
  for (const label of labels) {
    const record = store.get(label.id) || store.create(label.id, 'Label')

    const propertiesToSet: LabelPickerLabel = {
      id: label.id,
      color: label.color,
      name: label.name,
      nameHTML: label.nameHTML,
      description: label.description,
      url: label.url,
    }

    for (const [key, value] of Object.entries(propertiesToSet)) {
      if (value != null) {
        record.setValue(value, key)
      }
    }
  }
}

export function updateIssuesById(
  store: RecordSourceProxy,
  ids: string[],
  existingIssueLabels: Map<string, string[]>,
  connectionIds: {[key: string]: string[]},
  issueUpdateArgs: issueUpdateArgs,
) {
  for (const id of ids) {
    const issue = store.get(id)
    if (!issue) return
    const connections = connectionIds[id]?.map(cId => store.get(cId))

    for (const labelId of issueUpdateArgs.applyLabelIds) {
      if (existingIssueLabels.get(id)?.includes(labelId)) return
      const label = store.get(labelId)
      if (!label) return
      connections
        ?.filter(connection => connection)
        .map(connection => {
          const edge = connection && ConnectionHandler.createEdge(store, connection, label, 'LabelEdge')
          if (edge) ConnectionHandler.insertEdgeBefore(connection, edge)
        })
    }

    for (const labelId of issueUpdateArgs.removeLabelIds) {
      connections
        ?.filter(connection => connection)
        .map(connection => connection && ConnectionHandler.deleteNode(connection, labelId))
    }
  }
}
